import { useTranslation } from "react-i18next"
import { Link } from "wouter"

export const NotFoundPage = () => {
    const { t } = useTranslation()

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
            <div className="bg-white rounded-[40px] border border-slate-100 shadow-xl p-10 max-w-md w-full text-center">
                <div className="text-7xl font-black text-slate-100 mb-2">404</div>
                <h1 className="text-2xl font-black text-slate-800 mb-3">{t("notFound.title")}</h1>
                <p className="text-slate-500 font-bold mb-8">{t("notFound.description")}</p>
                <Link href="/">
                    <a className="inline-block bg-brand text-white font-black rounded-[28px] px-8 py-3 shadow-xl hover:bg-brand-dark active:scale-95 transition-all duration-200">
                        {t("notFound.backHome")}
                    </a>
                </Link>
            </div>
        </div>
    )
}
